
<h2 class="comp-title">Textbox</h2>
<form class="example-form">
  <mat-form-field class="example-full-width">
    <mat-label>הקלד רחוב</mat-label>
    <input matInput placeholder="" value="">
  </mat-form-field>
